import TopBar from "../../components/TopBar";

import "./index.scss";

const AppTermsOfUse = () => (
  <div className="app-terms-of-use">
    <TopBar heading="App Terms Of Use" />

    <div className="bold-description">Omni-Active® App User Agreement (“The Boring Part”)</div>
    <div className="bold-description">
      This is the only boring part of our mobile app (the “App”). Seriously though, it is important that you look
      through these terms properly as they determine how you can/cannot use the App and your relationship to
      Omni-Active®. You won’t be able to use the App unless you agree to these requirements.  So - if you are happy-
      click “agree” to confirm that you have read and understood these terms and that you agree to be legally bound by
      them. If you do not agree to these terms - you are going to have to miss out on using our App and you need to
      delete it from all your devices. 
    </div>
    <div className="bold-description">1. WHO WE ARE AND WHAT THESE TERMS DO </div>
    <div className="description">
      <strong>1.1 Who we are.</strong> This App is offered by <strong> Omni-Active® Fitness Limited.</strong> (we may
      refer to ourselves herein as “Omni-Active®”, “our”, “we” or “us,”). We are a limited liability company (LLC)
      registered in Cleveland, OH in the United States. 
    </div>
    <div className="description">
      <strong>1.2 What these terms cover and why you should read them.</strong> These terms govern the access or use by
      you, an individual, from any country or territory worldwide, of applications, websites, content, products, and
      services (the “Services") made available by Omni-Active®. PLEASE READ THESE TERMS CAREFULLY BEFORE ACCESSING OR
      USING THE APP OR THE SERVICES. In these terms, the words "including" and "include" mean "including, but not
      limited to”. These terms tell you who we are, how we will provide the App to you, how you or we may end the
      contract, how we may change the contract, what to do if there is a problem and other important information. If you
      think that there is a mistake in these terms, please contact us straight away. 
    </div>
    <div className="description">
      <strong>1.3 How we may contact you. </strong>If we need to contact you, we will do so either through an email
      address provided by you to us or through the App. 
    </div>
    <div className="description">
      <strong>1.4 Our Services.</strong> The Services we provide through our App is a technology platform that will
      enable you, as a user of our App, to view workouts built for you by our trainers, have access to nutritional
      information, access your account with us, receive sale alerts and promotional nudges. 
    </div>
    <div className="bold-description">2. USE OF THIS APP </div>
    <div className="description">
      <strong>2.1 This App and updates are only to be used by people who have registered with us.</strong> All use also
      needs to be in accordance with these terms only. If you have not registered with us, or are no longer registered
      with us, you need to immediately stop using the App and delete it from your device. 
    </div>
    <div className="description">
      <strong>2.2 Check that the App is suitable.</strong> This is not medical advice. Although we believe our app to be
      more thorough than most, it has not been developed to meet your every need. The app is for general purposes only,
      so, before starting this or any other fitness program, please consult with your physician. If they advise against
      it, don’t start the fitness program. If you experience faintness or severe dizziness, please seek medical
      attention immediately. The physical activities demonstrated on the App carry inherent risks including personal
      injury. You recognize that you undertake these activities at your own risk.
    </div>
    <div className="description">
      <strong>2.3 Ask the Professionals</strong> Though our fitness professionals are great at what they do, their
      advice should never substitute for medical advice, opinions, or treatment. Please always consult a medical
      professional prior to beginning or modifying any fitness or nutritional program.
    </div>
    <div className="description">
      <strong>2.4 You use the information on the App at your own risk- we aren’t forcing you.</strong> Although we make
      reasonable efforts to update the information provided by the App we make no representations, warranties or
      guarantees that such information is accurate, complete or up to date. 
    </div>
    <div className="description">
      <strong>2.5 Whose devices can I use the App on?</strong> You can only download, install and use this App on a
      device that you own or have permission to use for these purposes. You will be responsible for complying with these
      terms and for any use that is made of this App on another device, whether or not you own the device and/or if such
      use is with your knowledge or consent. 
    </div>
    <div className="description">
      <strong>2.6 Is my device compatible?</strong> The App should only be downloaded to and installed on a compatible
      device. Please read the App store listing for the App before downloading to ensure that your device is
      compatible. 
    </div>
    <div className="description">
      <strong>2.7 To make sure the App works, keep updating your device. </strong> You must ensure that the operating
      system on your device is kept updated to the latest version available to you. 
    </div>
    <div className="description">
      <strong>2.8 Updates to the App. </strong> Sometimes we might automatically update the App to make it even better,
      reflect changes that might be made to the operating system or sort out security issues. Please ensure you accept
      all updates we provide in respect of the App. If you choose not to install such updates or opt out of automatic
      updates you may not be able to continue using the App or you may find the functionality is reduced. The App will
      always match the description of it provided to you when you originally purchased it. 
    </div>
    <div className="bold-description">3. YOUR ACCOUNT </div>
    <div className="bold-description">3.1 Protect yourself! - keep your login details secret </div>
    <div className="description">
      3.1.1 You must keep any login details such as username, password and security questions confidential and not
      disclose them to any other person. If you have any reason to believe that they have been compromised, you must
      promptly reset them in the App using the ‘forgotten password' feature. 
    </div>
    <div className="description">
      3.1.2 You must not under any circumstances allow any other person to access the platform using your login details.
      Not only will it affect the functionality of the App as statistics and tracking will not be correct, but you will
      also be responsible for any actions taken by a person using your user account, whether or not with your knowledge
      or consent. 
    </div>
    <div className="description">
      3.1.3 Allowing others to access the App using your login details is a breach of these terms and may result in your
      right to use the App being suspended or us ending your right to use it. 
    </div>
    <div className="bold-description">4. YOUR RIGHT TO USE THIS APP </div>
    <div className="description">
      <strong>4.1 What can I do? </strong> In return for you agreeing to comply with these terms, you can: 
    </div>
    <div className="description">
      4.1.1 download or stream a copy of the App onto a compatible Apple device and view, use and display the App on
      such devices for your personal, non-commercial use only; 
    </div>
    <div className="description">
      4.1.2 receive and use any free supplementary software or updates to the App incorporating “patches” and
      corrections of errors as we may provide to you. 
    </div>
    <div className="description">
      <strong>4.2 Our App is subscription based-</strong> While you have an active subscription, Omni- Active® will
      provide new workout plans, updated monthly to help you reach your fitness goals. 
    </div>
    <div className="description">
      <strong>4.3 You must be over 12 to accept these terms and to download and use the App.</strong> We do not permit
      individuals under 12 years of age to become registered users of our App. By downloading the App, you represent and
      warrant that you are at least 12 years of age and have the right, authority and capacity to enter into these terms
      and to comply with these terms. 
    </div>
    <div className="description">
      <strong>4.4 If you are registered you are in!</strong> Provided that you are registered with us, subject to these
      terms, you may use the full functionality of this App by agreeing to these terms and entering your login details. 
    </div>
    <div className="description">
      <strong>4.5 So that you comply with Apple’s terms</strong> by clicking “Accept” below, you confirm that it is
      possible that the App and/or its contents could be subject to government export controls or other restrictions. If
      you download anything from or use the App, you represent that you are not subject to such controls or
      restrictions. You shall not, directly or indirectly, export, re-export, or release the App to, or make the App
      accessible from, any jurisdiction or country to which export, re-export, or release is prohibited by law, rule, or
      regulation. You shall comply with all applicable U.S. federal laws, regulations, and rules, and complete all
      required undertakings (including obtaining any necessary export license or other governmental approval), prior to
      exporting, re-exporting, releasing, or otherwise making the App available outside the U.S. {" "}
    </div>
    <div className="description">
      <strong>4.6 Suspension.</strong> We are entitled to suspend or end your right to use the App in various
      circumstances including if you break these terms. If you cease to be able to access the App you will need to
      address this with us. 
    </div>
    <div className="description">
      <strong>5. ACCEPTABLE USE</strong> The Omni-Active® App User Agreement (“The Boring Part”) This App is open to
      anyone that complies with these terms, and we want all members of our Omni-Active® community to feel welcome, so
      before you use the App, you agree that you will comply with our acceptable use requirements set out below at all
      times:  You will not access, store, distribute or transmit any viruses, code, programs or any material during the
      course of your use of the App or undertake any act or make an omission that: 
    </div>
    <div className="description">
      5.1.1 is unlawful, harmful, threatening, defamatory, obscene, infringing, harassing or racially, ethnically
      offensive or otherwise objectionable; 
    </div>
    <div className="description">5.1.2 facilitates illegal activity; </div>
    <div className="description">
      5.1.3 act fraudulently or maliciously, for example by hacking into or inserting malicious code, such as viruses or
      harmful data into the App or any operating system; 
    </div>
    <div className="description">5.1.4 depicts sexually explicit images; </div>
    <div className="description">5.1.5 promotes unlawful violence; </div>
    <div className="description">
      5.1.6 is discriminatory based on race, gender, colour, religious belief, sexual orientation, disability; 
    </div>
    <div className="description">
      5.1.7 infringe our intellectual property rights or those of any third party (including by the submission of any
      material); 
    </div>
    <div className="description">
      5.1.8 in a manner that is otherwise illegal or causes damage or injury to any person or property; or 
    </div>
    <div className="description">
      5.1.9 could damage, disable, overburden, impair or compromise our systems or security or interfere with other
      users; or 
    </div>
    <div className="description">
      5.1.10 collects or harvests any information or data from any system or attempt to decipher any transmissions to or
      from the servers running the App. 
    </div>
    <div className="bold-description">6. WHAT IF YOU NEED HELP?</div>
    <div className="description">
      <strong>6.1 If you need help (related to our App), contact Omni-Active®.</strong> We are always happy to help –
      see specific places to find help relating to the App in this paragraph 6. If you need life help – we hear you –
      there is plenty of useful stuff out there, but our App support just won’t cut it. 
    </div>
    <div className="description">
      <strong>6.2 Credential/logging in issues.</strong> If you need help with access credentials such as username,
      password and security questions then please contact our customer support team at support@omniactive.com. 
    </div>
    <div className="description">
      <strong>6.3 Other App Issues. </strong> Should you have a question or problem with the App you should use the live
      chat and in App ticketing support system to resolve this. 
    </div>
    <div className="description">
      <strong>6.4 It’s not Apple or Google’s fault. </strong> Anything to do with the App is our bag – so come to use
      with anything relating to the App and we will try to help you. Please leave Apple and Google alone to do what they
      do best! In the meantime, we will do our best to repair or replace the App. If we can’t fix a fault or can’t sort
      it within a reasonable time and without significant inconvenience you can get some or all of your money back. 
    </div>
    <div className="description">
      <strong>6.5 Contacting us with complaints. </strong> If you think the App is faulty or misdescribed or wish to
      contact us for any other reason, please email our fabulous customer support team at support@omniactive.com {" "}
    </div>
    <div className="description">
      <strong>6.6 Reviewing the App. </strong> If you choose to leave a review of the App on the app store, or other
      review platform, please ensure that you do so only (a) in good faith, (b) in accordance with the app store, or
      other platform, rules and guidelines and (c) from an account in your own name. Remember, the app store, or other
      platform, review system should not be used to raise questions or bug reports regarding the App. If your review
      relates to, refers to, or is influenced by a question or difficulty you have with the App, you should leave it
      only after having raised the issue through the live chat and in App ticketing support system and waiting a
      reasonable amount of time to receive a response. {" "}
    </div>
    <div className="bold-description">7. RESTRICTIONS ON YOUR USE OF THE APP </div>
    <div className="description">Other things you can’t do. You agree that you will: </div>
    <div className="description">
      7.1 not rent, lease, sub-license, loan, provide or otherwise make available, the App in any form, in whole or in
      part to any person without prior written consent from us; 
    </div>
    <div className="description">
      7.2 not copy the App (except where such copying is part of the normal use of the App, is necessary for the purpose
      of back-up as mentioned in paragraph 4.1.2 or operational security); 
    </div>
    <div className="description">
      7.3 not to side-load the App or otherwise install it other than via the relevant app store; 
    </div>
    <div className="description">
      7.4 not to translate, merge, adapt, vary, modify or alter the whole or any part of App, nor allow the App or any
      part of it to be combined with, or become incorporated in, any other programs except as necessary to use the App
      on devices as permitted in these terms (or except where permitted by law); 
    </div>
    <div className="description">
      7.5 not disassemble, de-compile, reverse engineer or create derivative works based on the whole or any part of the
      App nor attempt to do any such things; 
    </div>
    <div className="description">7.6 not to copy, reproduce or publish on any media athlete plans and workouts. </div>
    <div className="bold-description">8. OWNERSHIP OF STUFF</div>
    <div className="description">
      <strong>8.1 Ownership is ours. </strong> You acknowledge by agreeing to these terms that all intellectual property
      rights in the App and any related support services we provide anywhere in the world belong to us or our licensors
      and the rights in the App and any Services are licensed (not sold) to you to use the App. You have no intellectual
      property rights in, or to, the App or any Services other than the right to use them in accordance with these
      terms.   
    </div>
    <div className="description">
      <strong>8.2 Uploaded content will belong to us. </strong> We will treat any content you upload via the App as
      belonging to us. You must not upload any content via the App unless you have a right to do so and such content
      complies with the Acceptable Use section. 
    </div>
    <div className="description">
      <strong>
        8.3 If anyone else suggests our App or its use in line with these terms infringes their IP or has any other
        product claim regarding the App.{" "}
      </strong>{" "}
      We are responsible for investigating, defending, settling and discharging an infringement claim. 
    </div>
    <div className="bold-description">9. PROTECTING YOUR PRIVACY AND SECURITY </div>
    <div className="description">
      <strong>9.1 How we protect your personal information.</strong>
      We are committed to protecting your privacy and will only use your personal information in accordance with
      applicable data protection law. Our Privacy Notice explains how we use your personal information. All personal
      information we collect, use or otherwise process through or in connection with this App is subject to our Privacy
      Notice. 
    </div>
    <div className="description">
      <strong>9.2 The Internet isn’t perfect. </strong>
      As you know, internet transmissions are never completely private or secure and any message or information that you
      send using the App may be read or intercepted by others, even if there is a special notice that a particular
      transmission is encrypted. 
    </div>
    <div className="description">
      <strong>9.3 We may collect technical data about your device. </strong>
      By using the App, you agree to us collecting and using technical information about the devices you use the App on
      and related software, hardware and peripherals to improve our App and products. {" "}
    </div>
    <div className="description">
      <strong>9.4 Where are you? </strong>
      We don’t directly collect location data from you, though Apple and Google may collect such data and we may receive
      such data (but you can turn location services off in your settings). 
    </div>
    <div className="description">
      <strong>10. HOW ARE YOU COVERED IF SOMETHING GOES WRONG?  </strong>
      IF YOU LIVE IN THE UNITED STATES, THEN THIS CLAUSE 10 IS SUBJECT TO THE TERMS IN PARAGRAPH 14 IN RESPECT OF OUR
      LIABILITY TO YOU. FOR EVERYONE ELSE, (OUTSIDE THE US), PARAGRAPH 14 DOES NOT APPLY SO PLEASE READ THIS PARAGRAPH
      10 CAREFULLY). 
    </div>
    <div className="description">
      <strong>
        10.1 Although we don’t expect this to be necessary, we are responsible to you for foreseeable loss and damage
        caused by us.{" "}
      </strong>
      If we fail to comply with these terms, we are responsible for loss or damage you suffer that is a foreseeable
      result of our breaching these terms or our failing to use reasonable care and skill. You’ll appreciate though,
      that we are not responsible for any loss or damage that is not foreseeable. Loss or damage is foreseeable if
      either it is obvious that it will happen or if, at the time you accepted these terms, both we and you knew it
      might happen. 
    </div>
    <div className="description">
      <strong>10.2 We don’t exclude or limit our responsibility to you where it is unlawful to do so.</strong>
      This includes liability for death or personal injury caused by our gross negligence or the gross negligence of our
      employees, agents or subcontractors or for fraud or fraudulent misrepresentation by us. However, this does not
      mean that we are responsible for any personal injury or death caused as a result of you undertaking the workouts
      or using the App or Services as these may not be individually tailored to you. As recommended in paragraphs 2.2
      and 2.3, please see a doctor or medical professional to make sure you are good to go. 
    </div>
    <div className="description">
      <strong>10.3 When we are liable for damage to your stuff.</strong>
      If the App content that we have supplied is defective and damages a device or digital content belonging to you, we
      will either repair the damage or pay compensation. However, we will not be responsible for damage that you could
      have avoided by following our advice to apply an update offered to you free of charge, or for damage that was
      caused by you failing correctly to follow installation instructions or having the minimum system requirements in
      place. 
    </div>
    <div className="description">
      <strong>10.4 We are not liable for business or consequential losses.</strong>
      The App is for your private, personal, non-commercial use only. You should not use the App for any commercial,
      business or resale purposes and if you do, we will have no liability to you for any loss of profit, loss of
      business, business interruption or loss of business opportunity. 
    </div>
    <div className="description">
      <strong>10.5 We are not responsible for events outside our control.</strong>
      If our provision of support for the App or any additional services is delayed by an event outside our control (or
      if a server or the internet goes down, which means you can’t access the App), we will contact you as soon as
      possible to let you know and we will take steps to minimize the effect of the delay. Provided we do this, we will
      not be liable for delays caused by the event, but if there is a risk of a substantial delay, you may contact our
      customer support team at support@omniactive.com to end your contract with us. 
    </div>
    <div className="description">
      <strong>10.6 Back-up your stuff! </strong>
      We recommend that you regularly back up any content and data used in connection with the App, to protect yourself
      in case of problems with the App. Although the App should not normally cause any loss of data relating to other
      Apps or otherwise unrelated to the App, we cannot be responsible if you suffer a loss of data which could have
      been avoided if you had backed up the device immediately before such loss.   
    </div>
    <div className="bold-description">11. YOUR RIGHTS TO END THE CONTRACT </div>
    <div className="description">
      <strong>11.1 You can always end your contract with us. </strong>
      If you no longer want to use this App and want to delete your account that’s your choice, you can end your
      contract with us at anytime. We will not issue refunds for prepaid services, but we can extend expiration dates.
      You will have 60 days from the termination dates of your contract to use any remaining in-person or virtual
      sessions. 
    </div>
    <div className="description">
      <strong>11.2 How to end a contract with us. </strong>
      To end a contract with us, just contact our customer support team at support@omniactive.com. Simply deleting the
      app will not terminate your account with us. But please remember that when your account is deleted you will lose
      all of data within the App and you won’t be able to recover this and so if you want to keep anything please make
      sure anything you want to keep is backed up. 
    </div>
    <div className="bold-description">12. OUR RIGHTS TO END THE CONTRACT </div>
    <div className="description">
      <strong>12.1 We may end the contract if you break it. </strong>
      We may end your right to use the App at any time by contacting you if you have broken these terms in a serious
      way. If what you have done can be put right, we will give you a reasonable opportunity to do so. 
    </div>
    <div className="description">
      <strong>12.2 We may end the contract if we decide to suspend or stop providing the App. </strong>
      Sometimes, circumstances change and life moves on, and, although we can’t imagine it at the moment, at some point
      in the future, we may decide to stop providing our App to you. If we decide to suspend or stop providing our App,
      we will let you know if we are going to do this. 
    </div>
    <div className="description">
      <strong>12.3 If we end your rights to use the App. </strong>
      These are the consequences:
    </div>
    <div className="description">
      12.3.1 you must stop all activities authorized by these terms, including your use of the App; 
    </div>
    <div className="description">
      12.3.2 you must delete or remove the App form all devices in your possession and immediately destroy all copies of
      the App which you have and confirm to us that you have done this; 
    </div>
    <div className="description">
      12.3.3 we may remotely access your devices and remove the App from them and cease providing you with access to the
      support services. 
    </div>
    <div className="bold-description">13. OTHER IMPORTANT TERMS </div>
    <div className="description">
      <strong>13.1 Your use of the App may also be controlled by Apple’s or Google’s rules and policies. </strong>
      These rules and policies will apply in addition to these terms. To the extent there is a conflict, the Apple or
      Google rules and policies prevail. You will of course have to comply with your other programs terms with other
      providers too! 
    </div>
    <div className="description">
      <strong>13.2 From time to time, we may change, modify, supplement or remove portions of these terms </strong>
      to reflect changes in law or best practice or to deal with additional features which we introduce. If we do, you
      will receive a notification the next time you open the App and will be required to agree to the updated user
      agreement before you can continue to use the App. If you don’t accept these changes, you will not be permitted to
      use the App. 
    </div>
    <div className="description">
      <strong>13.3 This document and any terms referred to in it make up the entire user agreement </strong>
      between you and us relating to your use of the App. You acknowledge and accept that, in agreeing to the terms of
      this user agreement you have not relied on any representation, undertaking or promise except as set out in this
      user agreement. Neither you nor we will have any remedy in respect of any statement, representation, assurance or
      warranty (whether made innocently or negligently) that are not set out in these terms. 
    </div>
    <div className="description">
      <strong>13.4 We are not responsible for third party websites.</strong>
      The App may have links to other independent websites that are not provided by us. These sites are not controlled
      by us and we are not responsible for and have not checked and approved their content or their privacy policies (if
      any!). You will need to use your own independent judgment about whether to use such sites, including whether to
      buy any products or services offered by them.   
    </div>
    <div className="description">
      <strong>13.5 Even if we delay in enforcing this contract, we can still enforce it later.</strong>
      If we do not insist immediately that you do anything you are required to do under these terms, or if we delay in
      taking steps in respect of your breaking this contract that will not mean that you do not have to do those things
      and it will not prevent us taking steps against you at a later date. 
    </div>
    <div className="description">
      <strong>13.6 If a court finds part of this contract illegal, the rest will continue in force.</strong>
      Each of the paragraphs of these terms operates separately. If any court or relevant authority decides that any of
      them are unlawful, the remaining paragraphs will remain in full force and effect. 
    </div>
    <div className="description">
      <strong>13.7 We are giving you personally the right to use the App</strong>
      as set out above in paragraph 4 - You may not transfer the App to anyone else, whether for money, for anything
      else or even for free. If you sell or give away any device on which the App is installed, you need to uninstall it
      before you sell the device. 
    </div>
    <div className="description">
      <strong>13.8 Apple or Google can enforce these terms on our behalf to ensure you comply. </strong>
      Other than this, nothing in this user agreement confers any rights on any party other than you or us. 
    </div>
    <div className="description">
      <strong>13.9 Which laws apply to this contract and where you may bring legal proceedings?</strong>
      Good question! These terms are governed by U.S law and you can bring legal proceedings in respect of the App in
      the U.S. courts. 
    </div>
    <div className="bold-description">14. If you live in the United States the following additional terms apply: </div>
    <div className="description">
      14.1 IF YOU CHOOSE TO USE THE APP, YOU DO SO AT YOUR SOLE RISK. OMNI- ACTIVE® EXPLICITLY DISCLAIMS ANY WARRANTIES
      OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, QUIET ENJOYMENT OR NON- INFRINGEMENT, AND ANY WARRANTIES
      ARISING OUT OF COURSE OF DEALING OR USAGE OF TRADE THAT ARE NOT EXPRESSLY SET OUT IN THESE TERMS. OMNI-ACTIVE®
      MAKES NO WARRANTY THAT THE APP OR SERVICES WILL MEET YOUR REQUIREMENTS OR BE AVAILABLE ON AN UNINTERRUPTED,
      SECURE, OR ERROR-FREE BASIS. THE SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE." IN ADDITION, OMNI-ACTIVE® MAKES
      NO REPRESENTATION, WARRANTY, OR GUARANTEE REGARDING THE RELIABILITY, TIMELINESS, QUALITY, SUITABILITY, OR
      AVAILABILITY OF THE APP OR ANY SERVICES OR GOODS REQUESTED THROUGH THE USE OF THE APP, OR THAT THE SERVICES OR THE
      APP WILL BE UNINTERRUPTED OR ERROR-FREE. 
    </div>
    <div className="description">
      14.2 WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE CONTENT ON THE APP (INCLUDING ANY THIRD PARTY USER
      CONTENT), INCLUDING BUT NOT LIMITED TO ITS ACCURACY, RELIABILITY, COMPLETENESS, TIMELINESS, OR RELIABILITY. YOU
      AGREE THAT THE ENTIRE RISK ARISING OUT OF YOUR USE OF THE APP OR THE SERVICES, REMAINS SOLELY WITH YOU, TO THE
      MAXIMUM EXTENT PERMITTED UNDER APPLICABLE LAW.   
    </div>
    <div className="description">
      <strong>
        14.3 Our maximum aggregate liability under or in connection with these terms (including your use of any App or
        Services) whether in contract, tort (including negligence) any cause of action or otherwise, or under any theory
        of damages, shall in all circumstances be limited to the greater of (i) the amount you paid for the App and the
        Services in the last twelve (12) months; or (ii) $100. 
      </strong>
    </div>
    <div className="description">
      <strong>
        14.4 You agree to indemnify and hold Omni-Active® and its officers, directors, employees, and agents harmless
        from any and all claims, demands, losses, liabilities, and expenses (including attorneys' fees), arising out of
        or in connection with: (i) your use of the Services or services or goods obtained through your use of the App or
        Services; (ii) your breach or violation of any of these terms; (iii) Omni-Active’s use of your information or
        (iv) your violation of the rights of any third party, including third party providers. We reserve the right to
        assume control of the defense of any third party claim that is subject to your indemnification, in which case
        you will cooperate with us in asserting any available defenses. 
      </strong>
    </div>
    <div className="description">
      14.5 You agree that any dispute, claim or controversy arising out of or relating to these terms, the App or the
      breach, termination, enforcement, interpretation or validity thereof or the use of the Services (collectively,
      <strong>"Disputes"</strong>) will be settled by binding arbitration between you and Omni-Active®, except that each
      party retains the right to bring an individual action in small claims court and the right to seek injunctive or
      other equitable relief in a court of competent jurisdiction to prevent the actual or threatened infringement,
      misappropriation or violation of a party's copyrights, trademarks, trade secrets, patents or other intellectual
      property rights. 
    </div>
    <div className="description">
      14.5.1 You acknowledge and agree that you and Omni-Active® are each waiving the right to a trial by jury or to
      participate as a plaintiff or class in any purported class action or representative proceeding. Further, unless
      both you and Omni-Active® otherwise agree in writing, the arbitrator may not consolidate more than one person's
      claims, and may not otherwise preside over any form of any class or representative proceeding. If this specific
      paragraph is held unenforceable, then the entirety of this section 14.5.1 will be deemed void. Except as provided
      in the preceding sentence, this section 14.5.1 will survive any termination of these terms. 
    </div>
    <div className="description">
      14.5.2 The arbitration will be administered by the American Arbitration Association ("AAA") in accordance with the
      Consumer Arbitration Rules (the "AAA Rules") then in effect, except as modified by this "Dispute Resolution"
      section. (The AAA Rules are available at https://www.adr.org/consumer or by calling the AAA at 1-800-778-7879.)
      The Federal Arbitration Act will govern the interpretation and enforcement of this Section. These terms are
      governed by and construed in accordance with the laws of the State of New York, U.S.A., without giving effect to
      any conflict of law principles.  A party who desires to initiate arbitration must provide the other party with a
      written Demand for Arbitration as specified in the AAA Rules. (The AAA provides a form Demand for Arbitration at
      https://www.adr.org/consumer.) The arbitrator will be either a retired judge or an attorney licensed to practice
      law in the state of New York and will be selected by the parties from the AAA's roster of consumer dispute
      arbitrators. If the parties are unable to agree upon an arbitrator within seven (7) days of delivery of the Demand
      for Arbitration, then the AAA will appoint the arbitrator in accordance with the AAA Rules. 
    </div>
    <div className="description">
      14.5.3 Unless you and Omni-Active® otherwise agree, the arbitration will be conducted in the county where you
      reside. If your claim does not exceed $25,000, then the arbitration will be conducted solely on the basis of
      documents you and Omni-Active® submit to the arbitrator, unless you request a hearing or the arbitrator determines
      that a hearing is necessary. If your claim exceeds $25,000, your right to a hearing will be determined by the AAA
      Rules. Subject to the AAA Rules, the arbitrator will have the discretion to direct a reasonable exchange of
      information by the parties, consistent with the expedited nature of the arbitration. 
    </div>
    <div className="description">
      14.5.4 The arbitrator will render an award within the time frame specified in the AAA Rules. The arbitrator's
      decision will include the essential findings and conclusions upon which the arbitrator based the award. Judgment
      on the arbitration award may be entered in any court having jurisdiction thereof. The arbitrator's award damages
      must be consistent with the terms of the "Limitation of Liability" section above as to the types and the amounts
      of damages for which a party may be held liable. The arbitrator may award declaratory or injunctive relief only in
      favor of the claimant and only to the extent necessary to provide relief warranted by the claimant's individual
      claim. If you prevail in arbitration you will be entitled to an award of attorneys' fees and expenses, to the
      extent provided under applicable law. Omni-Active® will not seek, and hereby waives all rights Omni-Active® may
      have under applicable law to recover, attorneys' fees and expenses if Omni-Active®prevail in arbitration. 
    </div>
    <div className="description">
      14.5.5 Your responsibility to pay any AAA filing, administrative and arbitrator fees will be solely as set forth
      in the AAA Rules. 
    </div>
    <div className="description">
      14.6 We may also wish to stop providing the App, and may terminate use of it at any time without giving notice of
      termination to you. Unless we tell you otherwise, upon any termination, (a) the rights and licenses granted to you
      in these terms will end; (b) you must stop using the App, and (if needed) delete it from your device. 
    </div>
  </div>
);

export default AppTermsOfUse;
